import {NotificationEventPermissionCategory} from './notification-event-permission-category.model';
import {NotificationType} from './notification-type.model';

export class NotificationEvent {

    // Sever Properties
    ID: number;
    NotificationArea_ID: number;
    Name: string;
    Description: string;
    EnumerationValue: string;
    StoredProcedureName: string;
    Status: string;
    AllStaffGrantedAccess: boolean;
    ValidForStaff: boolean;
    ValidForStudents: boolean;
    ValidForParents: boolean;
    PermissionCategory: NotificationEventPermissionCategory;
    NotificationTypes: NotificationType[] = [];

    // Local Properties
    originalAllStaffGrantedAccess: boolean;
    areaName: string;
    groupNameDisplay: string;

    // Class Functions
    get hasChanges() {
        return this.originalAllStaffGrantedAccess != this.AllStaffGrantedAccess
            || (
                this.PermissionCategory
                && this.PermissionCategory.originalPermissionCategory != this.PermissionCategory.PermissionCategory
            );
    }

    // Methods
    hasType(typeID: number) {
        return this.NotificationTypes.find(o => o.ID == typeID);
    }

    getAreaDisplay(array: NotificationEvent[]) {
        const index = array.findIndex(o => o.ID == this.ID);
        let previousArea: string;
        if (index > 0) {
            previousArea = array[index - 1].areaName;
        }
        if (previousArea == null || previousArea != this.areaName) {
            return this.areaName;
        } else {
            return '';
        }
    }
}
